import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_dw_popup = _resolveComponent("dw-popup")!

  return (_openBlock(), _createBlock(_component_dw_popup, {
    title: "Переназначение",
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "dw-popup__form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_the_select, {
          value: _ctx.state.courierId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.courierId) = $event)),
          placeholder: "Выберите курьера",
          options: _ctx.couriers_state.list,
          loading: _ctx.couriers_state.is_loading,
          failed: _ctx.couriers_state.is_failed,
          "error-text": "При получении списка курьеров произошла ошибка",
          label: "fullName",
          "search-without-refresh": "",
          "search-by": "fullName",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.validation$.courierId.$error,
          "validation-errors": _ctx.validation$.courierId.$errors
        }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"]),
        _createVNode(_component_dw_button, {
          type: "submit",
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Переназначить")
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["onClose"]))
}